import ar from '@angular/common/locales/ar';

export const localeAr = {
  ...ar,
  [14]: [
    ar[14][0],
    ar[14][1],
    '#,##0.00 ¤‎',
    ar[14][3],
  ],
};
